import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CustomOrderService } from '../../order/core/order.service';
import { Order } from '@spartacus/order/root';

@Component({
  selector: 'recent-orders',
  templateUrl: './recent-orders.component.html',
  styleUrl: './recent-orders.component.scss',
  standalone: false,
})
export class RecentOrdersComponent implements OnInit {
  subscription = new Subscription();

  ordersRequest$ = new BehaviorSubject<Order[]>([]);

  constructor(private _orderService: CustomOrderService) {}

  ngOnInit(): void {
    this.getOrders();
  }

  getOrders() {
    const query = this.buildQuery();

    this.subscription.add(
      this._orderService.getOrders(query).subscribe(response => {
        const orders = response.orders
          ? response.orders
              ?.sort((a, b) => {
                const timeA = a.created ? a.created.getTime() : 0;
                const timeB = b.created ? b.created.getTime() : 0;
                return timeB - timeA;
              })
              .slice(0, 5)
          : [];

        this.ordersRequest$.next(orders);
      }),
    );
  }

  buildQuery(): any {
    return {
      fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0],
      toDate: new Date().toISOString().split('T')[0],
      openOnly: false,
    };
  }
}
